/**
 * @param {HTMLElement} scope context in which to operate
 * @return {void}
 */
export default function toggler(scope = document) {
  const triggers = [].slice.call(scope.querySelectorAll('[data-toggle]'));

  triggers.forEach((trigger) => {
    trigger.addEventListener('click', () => {
      const targetIds = trigger.dataset.toggle.split(' ');

      // loop trough the IDs
      targetIds.forEach((targetId) => {
        const target = document.getElementById(targetId);

        // toggle targets specified class
        if (target !== null && ('toggler' in target.dataset)) {
          target.classList.toggle(target.dataset.toggler);
        }
      });
    });
  });
}



// WEBPACK FOOTER //
// ./assets/js/components/toggler.js